// extracted by mini-css-extract-plugin
export default {"wrap":"status_wrap__wwU8N","content":"status_content__NzABm","image":"status_image__E1y4U"};